import { formatDate } from "@pages/Project/utils/utils";
import Pill from "@shared/components/Pill";
import { Tooltip } from "flowbite-react";
import React from "react";

export interface LatestUpdate {
  id: string;
  title: string;
  description: string;
  date: string;
  report_id: string;
  project_id: string;
  pending_suggestions_count: number;
}

interface LatestUpdatesPanelProps {
  openUpdatesDetailModal: () => void;
  setSelectedUpdate: (value: React.SetStateAction<LatestUpdate>) => void;
  upcomingItems: LatestUpdate[];
  fetchLatestUpdates: () => void;
}

const LatestUpdatesPanel: React.FC<LatestUpdatesPanelProps> = ({
  openUpdatesDetailModal,
  setSelectedUpdate,
  upcomingItems,
  fetchLatestUpdates,
}) => {
  const pendingCount = upcomingItems.reduce(
    (sum, item) => sum + (item.pending_suggestions_count || 0),
    0
  );

  return (
    <div className="flex-1 bg-white rounded-md border text-sm 2xl:text-base border-gray-200 overflow-hidden flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
        <div className="flex items-center space-x-4">
          <h2 className="font-semibold text-gray-900 py-2">Latest Updates</h2>
          {pendingCount > 0 && (
            <Pill
              text={`${pendingCount} Pending reviews`}
              styling="bg-gray-200 text-gray-500 border-gray-400"
            />
          )}
        </div>
        <button onClick={fetchLatestUpdates}>
          <Tooltip content="Refresh updates" placement="top" arrow={false}>
            <img
              src="/refresh.svg"
              className="w-4 h-4 2xl:w-5 2xl:h-5 cursor-pointer"
              alt=""
            />
          </Tooltip>
        </button>
      </div>

      {/* Items */}
      <div className="flex-1 overflow-y-auto">
        {upcomingItems.length === 0 && (
          <div className="px-4 py-3 text-gray-500 text-sm 2xl:text-base flex items-center justify-center h-full">
            No updates available.
          </div>
        )}
        {upcomingItems.length > 0 &&
          upcomingItems.map((item, idx) => (
            <div
              key={idx}
              className="px-4 py-3 border-b last:border-b-0 border-gray-100 flex flex-col space-y-2"
            >
              <div className="flex">
                <div className="w-[80%]">
                  <p className="font-semibold text-sm 2xl:text-base text-gray-900 line-clamp-2 text-ellipsis">
                    {item.title}
                  </p>
                </div>
                {item.pending_suggestions_count > 0 && (
                  <div className="w-[20%] flex justify-end ">
                    <button
                      className="cursor-pointer"
                      onClick={() => {
                        openUpdatesDetailModal();
                        setSelectedUpdate(item);
                      }}
                    >
                      <img src="/alert-circle.svg" alt="" />
                    </button>
                  </div>
                )}
              </div>
              <p className="text-gray-700 text-xs 2xl:text-sm line-clamp-3 text-ellipsis w-[90%]">
                {item.description}
              </p>
              <div className="flex justify-between">
                <p className="text-gray-400 text-xs 2xl:text-sm">
                  {item.date ? formatDate(new Date(item.date)) : ""}
                </p>
                <p
                  className="text-blue-600 cursor-pointer text-xs 2xl:text-sm"
                  onClick={() => {
                    openUpdatesDetailModal();
                    setSelectedUpdate(item);
                  }}
                >
                  View more
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default LatestUpdatesPanel;
